import React, { Component } from 'react';
import BoxJob from './BoxJob';
import BatchBoxJobItem from './BatchBoxJobItem';
import EditBoxJobQueueItemForm from './EditBoxJobQueueItemForm';
import {
    Row, Col, Badge, Collapse, Card, Button,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Alert, UncontrolledTooltip
} from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faFlag, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { humanize } from '../../box-helpers';

class BatchReservation extends Component {
    state = {
        expanded: this.props.batchType === 'received' ? true : false,
        deleting: false,
        batchType: this.props.batchType || 'active',
        openFlagModal: false,
        activeBoxJob: null,
        activeQueueItem: null,
        activeBoxConfigurationId: null,
        activeBoxConfigurationBatchId: null,
        actionType: null,
        alertMsg: "",
        showAlert: false,
        queueItemOverrides: {}
    }

    toggleExpand = () => {
        this.setState(prevState => ({ expanded: !prevState.expanded }));
    }

    handleDelete = async () => {
        const { batch, os, onDelete } = this.props;
        let boxConfigBatch  = batch.box_configuration_batch || {};
        console.log('Attempting to delete batch:', boxConfigBatch);
        if (!window.confirm(`Are you sure you want to delete the batch "${boxConfigBatch.name}"? This action cannot be undone.`)) {
            return;
        }

        this.setState({ deleting: true });

        try {
            const token = JSON.parse(localStorage.getItem("token"));
            await os.deleteBoxConfigurationBatch(token, boxConfigBatch.id);

            // Call parent callback to refresh the list
            if (onDelete) {
                onDelete(batch.id);
            }
        } catch (error) {
            console.error('Error deleting batch:', error);
            alert('Failed to delete batch. Please try again.');
            this.setState({ deleting: false });
        }
    }

    getStatusBadge = (status) => {
        const statusColors = {
            'active': 'primary',
            'reserved': 'info',
            'pending': 'warning',
            'completed': 'success',
            'received': 'success',
            'cancelled': 'secondary'
        };
        return statusColors[status] || 'secondary';
    }

    formatDate = (dateString) => {
        return moment(dateString).format('MMM DD, YYYY');
    }

    toggleFlagModal = (boxJob = null, actionType = null, boxConfigurationId = null, boxConfigurationBatchId = null, queueItem = null) => {
        this.setState(prevState => ({
            openFlagModal: !prevState.openFlagModal,
            activeBoxJob: boxJob,
            activeQueueItem: queueItem,
            activeBoxConfigurationId: boxConfigurationId,
            activeBoxConfigurationBatchId: boxConfigurationBatchId,
            actionType: actionType,
            showAlert: false,
            alertMsg: ""
        }));
    }

    closeModal = () => {
        this.setState({
            openFlagModal: false,
            activeBoxJob: null,
            activeQueueItem: null,
            activeBoxConfigurationId: null,
            activeBoxConfigurationBatchId: null,
            actionType: null
        });
    }

    closeAndRefresh = () => {
        this.closeModal();
        if (this.props.onBatchUpdate) {
            this.props.onBatchUpdate();
        } else {
            window.location.reload();
        }
    }

    extractUpdatedQueueItem = (data) => {
        if (!data) return null;
        if (data.box_job_queue_item && data.box_job_queue_item.id) return data.box_job_queue_item;
        if (data.box_job && Array.isArray(data.box_job.box_job_queue_items)) {
            const { activeQueueItem } = this.state;
            if (activeQueueItem) {
                const match = data.box_job.box_job_queue_items.find((qi) => qi.id === activeQueueItem.id);
                if (match) return match;
            }
        }
        if (data.id) return data;
        return null;
    }

    handleQueueItemSaved = (data) => {
        const updated = this.extractUpdatedQueueItem(data);
        if (updated) {
            this.setState((prev) => ({
                queueItemOverrides: {
                    ...prev.queueItemOverrides,
                    [updated.id]: updated
                }
            }));
        }
        this.closeModal();
        if (this.props.onBatchUpdate) {
            this.props.onBatchUpdate();
        }
    }

    applyQueueItemOverrides = (boxJob) => {
        const overrides = this.state.queueItemOverrides;
        if (!boxJob || !boxJob.box_job_queue_items || Object.keys(overrides).length === 0) {
            return boxJob;
        }
        const merged = boxJob.box_job_queue_items.map((qi) => (overrides[qi.id] ? overrides[qi.id] : qi));
        return { ...boxJob, box_job_queue_items: merged };
    }

    printFlaggedItem = async () => {
        const { activeBoxJob, activeQueueItem } = this.state;

        if (!activeBoxJob || !activeQueueItem) return;

        this.setState({ showAlert: false });

        try {
            let token = JSON.parse(localStorage.getItem("token"));

            var result = await fetch(
                process.env.REACT_APP_API_URL + '/api/v4/box_jobs/' + activeBoxJob.id + '/box_job_queue_items/' + activeQueueItem.id,
                {
                    method: 'PUT',
                    headers: {
                        'Authorization': "Bearer " + token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ignore_flags: true })
                }
            )
            .then(response => response.json())
            .then(data => {
                return data;
            })
            .catch((error) => {
                this.setState({ showAlert: true, alertMsg: error.message })
                return { errors: error.message };
            });

            if (result && result.errors) {
                this.processResult(result, this.state.showAlert, false);
                return;
            }

            this.handleQueueItemSaved(result);
        } catch (error) {
            console.error('Error updating box job queue item:', error);
            this.setState({ showAlert: true, alertMsg: "Failed to update box job queue item" });
        }
    }

    processResult = (result, is_error, reload_window) => {
        if (is_error) {
            this.setState({ alertMsg: "An error occurred", showAlert: true })
        } else if (result["errors"]) {
            console.log('result error: ', result["errors"]);
            let errors = "";
            if (typeof result["errors"] === 'string') {
                errors = result["errors"];
            } else {
                errors = Object.keys(result["errors"]).map(key => {
                    let human_key = humanize(key);
                    return human_key + " " + result["errors"][key];
                })
            }
            this.setState({ alertMsg: errors, showAlert: true })
        } else if (reload_window) {
            this.closeAndRefresh();
        }
    }

    renderBoxJobs = () => {
        const { batch } = this.props;
        const items = batch.box_configuration_batch?.box_configuration_batch_items || [];
        const batchId = batch.box_configuration_batch?.id;

        // Collect ALL unfinished box jobs along with their box_configuration_id
        let allJobsWithConfig = [];
        items.forEach(item => {
            if (item.unfinished_box_jobs && item.unfinished_box_jobs.length > 0) {
                item.unfinished_box_jobs.forEach(job => {
                    allJobsWithConfig.push({
                        job: job,
                        boxConfigurationId: item.box_configuration?.id,
                        configurationName: item.box_configuration?.name
                    });
                });
            }
        });

        if (allJobsWithConfig.length === 0) {
            return <span className="text-muted" style={{ fontSize: '0.85rem' }}>No box jobs</span>;
        }

        return allJobsWithConfig.map(({ job, boxConfigurationId, configurationName }) => (
            <BatchBoxJobItem
                key={job.id}
                boxJob={this.applyQueueItemOverrides(job)}
                batchId={batchId}
                boxConfigurationId={boxConfigurationId}
                boxConfigurationBatchId={batchId}
                configurationName={configurationName}
                onOpenModal={this.toggleFlagModal}
            />
        ));
    }

    render() {
        const { batch } = this.props;
        const { expanded } = this.state;

        if (!batch) return null;

        const items = batch.box_configuration_batch?.box_configuration_batch_items || [];
        const requiredProducts = batch.box_configuration_batch?.aggregated_product_requirements || [];

        return (
            <div className="border-bottom pb-2">
                <Row className="align-items-start">
                    <Col className="col" lg={3} md={5} sm={5} xs={5}>
                        <div
                            onClick={this.toggleExpand}
                            style={{ cursor: 'pointer' }}
                            className="d-flex align-items-center float-left"
                        >
                            <FontAwesomeIcon
                                icon={expanded ? faChevronDown : faChevronRight}
                                className="mr-2 text-muted"
                                style={{ width: '12px' }}
                            />
                            <div>
                                <strong>{batch.name}</strong>
                                <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                                    {batch.configuration_count} {batch.configuration_count === 1 ? 'template' : 'templates'} | {batch.total_quantity} total boxes
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col" lg={2} md={2} sm={2} xs={2}>
                        <Badge color={this.getStatusBadge(batch.status)} className="mr-2">
                            {batch.status}
                        </Badge>
                        {batch.completed_at && (
                             <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                                {this.formatDate(batch.completed_at)}
                            </span>
                        )}
                        {!batch.completed_at && (
                             <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                                {this.formatDate(batch.created_at)}
                            </span>
                        )}
                        {batch.reserved_configurations && batch.reserved_configurations.length > 0 && (
                            <Badge color="success">Reserved</Badge>
                        )}
                    </Col>
                    <Col className="col" lg={5} md={4} sm={2} xs={2}>
                        {batch.order ? (
                            <div>
                                <div className="text-success">Order #{batch.order.order_number}</div>
                                <div className="text-muted" style={{ fontSize: '0.85rem' }}> Status: {batch.order.status}</div>
                            </div>
                        ) : (
                            <span className="text-muted">Awaiting order</span>
                        )}
                    </Col>

                    <Col className="col text-right" lg={2} md={2} sm={1} xs={1}>
                        <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                            {this.formatDate(batch.created_at)}
                        </span>
                        {!batch.order && (
                            <Button
                                color="danger"
                                size="sm"
                                className="ml-2"
                                onClick={this.handleDelete}
                                disabled={this.state.deleting}
                                title="Delete Reservation"
                            >
                                <FontAwesomeIcon icon={faTrash} />
                                {this.state.deleting ? ' Deleting...' : ''}
                            </Button>
                        )}
                    </Col>
                </Row>

                <Collapse isOpen={expanded}>
                    <Card className="mt-2 mb-1 bg-light px-4">
                        <Row>
                            <Col className="p-2" lg={4} md={4} sm={12} xs={12}>
                                <strong className="d-block mb-2">Templates in this batch:</strong>
                                {items.map((item, index) => (
                                    <Row className="mb-2 d-flex justify-content-between py-1 px-4" key={item.id || index}>
                                        <Col className="m-2" lg={7} md={7} sm={6} xs={6}>
                                            <span className="mr-2">{item.box_configuration?.name || 'Configuration'}</span>
                                            <span className="text-muted">
                                                ({item.box_configuration?.enclosure_type} {item.box_configuration?.powder_color})
                                            </span>
                                        </Col>
                                        <Col className="p-2" lg={3} md={3} sm={3} xs={3}>
                                            <Badge color="secondary">Qty: {item.qty}</Badge>
                                        </Col>
                                    </Row>
                                ))}
                            </Col>
                            <Col className="p-2" lg={3} md={3} sm={12} xs={12}>
                                { requiredProducts.length > 0 && (
                                    <div>
                                        <strong>Products:</strong>
                                        {requiredProducts.map((product, index) => (
                                            product.qty > 0 && (
                                                <div key={index} style={{ fontSize: '0.75rem' }}>
                                                    <span className='text-muted'>{product.product_name}</span> <Badge color="light">Qty: {product.qty}</Badge>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                )}
                            </Col>
                            <Col className="p-2" lg={5} md={5} sm={12} xs={12}>
                                <strong className="d-block">Box Jobs:</strong>
                                {this.renderBoxJobs()}
                            </Col>
                        </Row>
                    </Card>
                </Collapse>

                {/* Modal for Box Job Queue Item Actions */}
                <Modal isOpen={this.state.openFlagModal} toggle={() => this.toggleFlagModal()} size={this.state.actionType === 'edit' ? 'lg' : null}>
                    <ModalHeader toggle={() => this.toggleFlagModal()}>
                        {this.state.actionType === 'edit' ? 'Edit Box Job Item' : 'Print Item As Is'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.activeBoxJob && (
                            <>
                                <h5>Box Job #{this.state.activeBoxJob.id}</h5>
                                <p><strong>{this.state.activeBoxJob.enclosure_type} {this.state.activeBoxJob.powder_color}</strong> - Qty: {this.state.activeBoxJob.quantity}</p>

                                {this.state.actionType === 'edit' && this.state.activeQueueItem && (
                                    <EditBoxJobQueueItemForm
                                        boxJobId={this.state.activeBoxJob.id}
                                        queueItemId={this.state.activeQueueItem.id}
                                        boxJob={this.state.activeBoxJob}
                                        enclosureType={this.state.activeBoxJob.enclosure_type}
                                        powderColor={this.state.activeBoxJob.powder_color}
                                        onSaved={this.handleQueueItemSaved}
                                    />
                                )}

                                {this.state.actionType === 'printAsIs' && (
                                    <div>
                                        <h6>Confirm Print As Is</h6>
                                        <p>Click Print As Is to confirm that you don't want to correct the issues and want to proceed with printing this item as is.</p>
                                    </div>
                                )}

                                <Alert color="danger" isOpen={this.state.showAlert === true}>
                                    {this.state.alertMsg}
                                </Alert>
                            </>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        {this.state.actionType === 'printAsIs' && (
                            <Button color="info" onClick={this.printFlaggedItem}>Print As Is</Button>
                        )}
                        <Button color="secondary" onClick={() => this.toggleFlagModal()}>
                            {this.state.actionType === 'edit' ? 'Close' : 'Cancel'}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default BatchReservation;
